import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { Route, RouterModule } from '@angular/router';
import { OutboundTableComponent } from 'src/app/components/outbound/outbound-table/outbound-table.component';
import { OutboundComponent } from '../../components/outbound/outbound.component';
import { SharedModule } from '../shared-module/shared.module';

const routes: Route[] = [
  {
    path: 'outbound',
    component: OutboundComponent,
    children: [ { path: 'create', component: OutboundComponent, outlet: 'side' } ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatIconModule,
    FormsModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ OutboundComponent, OutboundTableComponent ],
  exports: [ OutboundComponent, OutboundTableComponent ]
})
export class OutboundModule {}
